import { Link } from 'react-router-dom';

const tiers = [
  {
    name: 'Starter',
    price: '$499',
    features: ['1 usuario', '50 propiedades', 'Selecciones compartibles', 'Buscador público'],
    highlight: false,
  },
  {
    name: 'Professional',
    price: '$1,999',
    features: ['10 usuarios', '500 propiedades', 'Módulo de rentas completo', 'Seguimiento de prospectos'],
    highlight: true,
  },
  {
    name: 'Enterprise',
    price: '$4,999',
    features: ['Usuarios ilimitados', 'Propiedades ilimitadas', 'Integraciones a la medida', 'Soporte prioritario'],
    highlight: false,
  },
];

export default function PricingSection() {
  return (
    <section id="precios" className="max-w-6xl mx-auto px-6 py-20 scroll-mt-20">
      <p className="text-[11px] font-semibold tracking-[0.25em] text-[#8A8578] uppercase">Precios</p>
      <h2 className="mt-3 text-3xl sm:text-4xl tracking-tight">
        <span className="font-extrabold text-[#141414]">Simple. </span>
        <span className="italic font-semibold text-[#8A8578]">Crece cuando tú crezcas.</span>
      </h2>
      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4 items-start">
        {tiers.map((t) => (
          <div
            key={t.name}
            className={`relative bg-white rounded-2xl p-7 shadow-[0_24px_60px_-40px_rgba(20,20,20,0.35)] ${
              t.highlight ? 'ring-2 ring-[#141414] md:-mt-3' : ''
            }`}
          >
            {t.highlight && (
              <span className="absolute -top-3 left-6 text-[10px] font-semibold tracking-wider uppercase bg-[#141414] text-white rounded-full px-3 py-1">
                Recomendado
              </span>
            )}
            <h3 className="font-bold text-[#141414]">{t.name}</h3>
            <p className="mt-3">
              <span className="text-4xl font-extrabold tracking-tight text-[#141414]">{t.price}</span>
              <span className="text-sm text-[#8A8578]"> MXN / mes</span>
            </p>
            <ul className="mt-5 space-y-2">
              {t.features.map((f) => (
                <li key={f} className="flex items-center gap-2 text-sm text-[#141414]/75">
                  <svg viewBox="0 0 16 16" className="w-4 h-4 shrink-0" aria-hidden="true">
                    <rect width="16" height="16" rx="8" fill="#DDF3E4" />
                    <path d="M4.5 8.5l2.2 2.2L11.5 6" stroke="#22A65B" strokeWidth="1.8" fill="none" strokeLinecap="round" />
                  </svg>
                  {f}
                </li>
              ))}
            </ul>
            <Link
              to="/register"
              className={`mt-7 block text-center text-sm font-semibold rounded-full px-6 py-3 transition-colors ${
                t.highlight
                  ? 'bg-[#141414] text-white hover:bg-[#2a2a28]'
                  : 'border border-[#141414]/15 text-[#141414] hover:bg-[#141414] hover:text-white'
              }`}
            >
              Comenzar
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}
